// extracted by mini-css-extract-plugin
export default {"country_form":"styles_country_form__DJW3M","title":"styles_title__i8O6D","select":"styles_select__0wSKc","text":"styles_text__Rc5ax"};